export enum ENUM__grid2d_feature {
  /*
   *
   */
  CELLS__SORT = 'CELLS__SORT',

  /*
   *
   */

  IMAGE_EXTERNAL__ADD = 'IMAGE_EXTERNAL__ADD', //upload

  IMAGE_INTERNAL__DELETE = 'IMAGE_INTERNAL__DELETE',
  IMAGE_INTERNAL__ADD = 'IMAGE_INTERNAL__ADD',
}
